<template>
    <span>
        <span v-if="playerData.synced">
            <i class="fas fa-sync-alt mr-1 text-success"></i> Sincronizado
        </span>
        <span v-else>
            <span v-if="playerData.syncing">
                <i class="fas fa-sync-alt fa-spin mr-1 text-info"></i> Sincronizando ...
            </span>
            <span v-else>
                <span v-if="playerData.last_synced">
                    <i class="fas fa-sync-alt mr-1 text-danger"></i> Última Sincronia {{ lastSyncedData }}
                </span>
                <span v-else>
                    <i class="fas fa-sync-alt mr-1"></i> Nunca Sincronizado
                </span>
            </span>
        </span>
    </span>
</template>

<script>
    export default {
        props: ['player'],
        data() {
            return {
                playerData: this.player,
                channel: Echo.channel('App.PlayerSync.' + this.player.id),
                lastSyncedData: '',
                timerSyncedData: null,
            }
        },
        watch: {
            async player(playerNew, playerOld) {
                // Update Date
                this.playerData = playerNew;

                // Calc Last Update
                this.lastSyncedData = this.calcLastSyncedData(playerNew.last_synced)

                // Unsubscribe
                await this.channel.unsubscribe();

                // Start Channel Listener
                this.channel = await Echo.channel('App.PlayerSync.' + playerNew.id);

                // Subscribe
                this.channel.subscribe();

                // Event
                await this.channel
                    .listen('.synced-from-player', (e) => {
                        // Update Player Data
                        this.playerData = e.player;
                    })
                    .listen('.syncing-from-player', (e) => {
                        // Update Player Data
                        this.playerData = e.player;
                    })
                    .listen('.un-sync-from-player', (e) => {
                        // Update Player Data
                        this.playerData = e.player;
                    })

            }
        },
        async mounted() {

            // Unsubscribe
            await this.channel.unsubscribe();

            // Start Channel Listener
            this.channel = await Echo.channel('App.PlayerSync.' + this.playerData.id);

            // Subscribe
            await this.channel.subscribe();

            // Event
            this.channel
                .listen('.synced-from-player', (e) => {
                    // Update Player Data
                    this.playerData = e.player;
                })
                .listen('.syncing-from-player', (e) => {
                    // Update Player Data
                    this.playerData = e.player;
                })
                .listen('.un-sync-from-player', (e) => {
                    // Update Player Data
                    this.playerData = e.player;
                })

            // Calc Last Update
            this.lastSyncedData = this.calcLastSyncedData(this.playerData.last_synced)

            // Timer Synced
            this.timerSyncedData = setInterval(() => {
                this.lastSyncedData = this.calcLastSyncedData(this.playerData.last_synced)
            }, 1000)

        },
        beforeDestroy() {
            // Unsubscribe
            Echo.channel('App.PlayerSync.' + this.playerData.id).unsubscribe();

            // Cancel Interval
            clearInterval(this.timerSyncedData);
        },
        methods: {
            calcLastSyncedData(data) {
                if (data) {
                    return this.$moment(data).fromNow()
                }
                return '';
            },
        }
    }
</script>

<style scoped>

</style>
